module.exports = __webpack_public_path__ + "img/58.3dcfc9e2.png";